import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store'; // Adjust the import path if needed

const paginationSlice = createSlice({
    name: 'pagination',
    initialState: {
        rowsPerPage: 10, // default value
    },
    reducers: {
        setPageSize: (state, action: PayloadAction<number>) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const { setPageSize } = paginationSlice.actions;
export const selectRowsPerPage = (state: RootState) => state.pagination.rowsPerPage;
export default paginationSlice.reducer;